import { CartModule } from './cart/cart.module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AccountModule } from './account/account.module';
import { AccountConfigServiceOption } from './account/services/account-config/account-config.service';
import { AuthModule } from './auth/auth.module';
import { AuthConfigServiceOption } from './auth/services/auth-config/auth-config.service';
import { CartConfigServiceOption } from './cart/services/cart-config/cart-config.service';
import { CatalogModule } from './catalog/catalog.module';
import { CatalogConfigServiceOption } from './catalog/services/catalog-config/catalog-config.service';
import { WpModule } from './wp/wp.module';
import { WpConfigServiceOption } from './wp/services/wp-config/wp-config.service';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [],
  imports: [CartModule, CommonModule, AccountModule, AuthModule, CatalogModule, WpModule],
  exports: [CartModule, CommonModule, AccountModule, AuthModule, CatalogModule, WpModule]
})
export class CoreModule {
  public static forRoot(config?: {
    account?: AccountConfigServiceOption;
    auth?: AuthConfigServiceOption;
    cart?: CartConfigServiceOption;
    catalog?: CatalogConfigServiceOption;
    wp?: WpConfigServiceOption;
  }): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: AccountConfigServiceOption,
          useValue: config ? config.account : null
        },
        {
          provide: AuthConfigServiceOption,
          useValue: config ? config.auth : null
        },
        {
          provide: CartConfigServiceOption,
          useValue: config ? config.cart : null
        },
        {
          provide: CatalogConfigServiceOption,
          useValue: config ? config.catalog : null
        },
        {
          provide: WpConfigServiceOption,
          useValue: config ? config.wp : null
        }
      ]
    };
  }
}
